import type { U2000TableColumn } from '../components/tables/basic/U2000BasicTableList';
import type { U2000FieldItem } from '../components/tables/commons/search/U2000BasicSearchField';
import type { SortedFieldItem } from '../components/tables/commons/search/U2000BasicSearchSort';
import type { Criteria, Field, SortedField, U2000SearchStateFilter } from '../reducer/formReducer/U2000SearchState';
import {
  u2000SerializeCriteriaDateForStorage,
  type U2000SnapshotDateOptions,
} from './u2000DynamicSearchDateUtils';

/** Retire les propriétés non sérialisables (fonctions React) avant localStorage. */
function u2000SerializeTableColumn(col: U2000TableColumn): U2000TableColumn {
  const { display: _display, headerDisplay: _headerDisplay, ...rest } = col as U2000TableColumn & {
    display?: unknown;
    headerDisplay?: unknown;
  };
  return { ...rest };
}

function u2000SerializeCriteriaForStorage(c: Criteria, dateOptions?: U2000SnapshotDateOptions): Criteria {
  const serialized: Criteria = {
    ...c,
    field: u2000SerializeTableColumn(c.field),
  };
  if (!dateOptions) {
    return serialized;
  }
  return u2000SerializeCriteriaDateForStorage(
    serialized,
    Boolean(dateOptions.makeDatesDynamic),
    dateOptions.referenceTodayYmd,
  );
}

/** Copie profonde du filtre courant, compatible JSON.stringify / localStorage. */
export function u2000SnapshotCurrentFilterForStorage(
  getCriterias: () => Criteria[],
  getFields: () => U2000FieldItem[],
  getSortedFields: () => SortedFieldItem[],
  dateOptions?: U2000SnapshotDateOptions,
): U2000SearchStateFilter {
  return {
    criterias: getCriterias().map((c) => u2000SerializeCriteriaForStorage(c, dateOptions)),
    // Cast : forme de stockage réelle `{ field }` (voir U2000FieldItem), lue via getFields() côté U2000SearchStateHandlers.
    fields: getFields().map((f) => ({
      field: u2000SerializeTableColumn(f.field),
    })) as unknown as Field[],
    sortedFields: getSortedFields().map((s) => ({
      field: u2000SerializeTableColumn(s.field),
      sortOrder: s.sortOrder,
    })) as unknown as SortedField[],
  };
}
